export type EnumConstant<T extends string | number = string | number> = {
  value: T
  label: string
}

// 提取常量对象所有 value 的联合类型
export type EnumValueType<T extends Record<string, { value: any }>> = T[keyof T]['value']
export type EnumLabelType<T extends Record<string, { label: any }>> = T[keyof T]['label']

export class EnumUtils<T extends string | number> {
  private constants: Record<string, EnumConstant<T>>

  constructor(constants: Record<string, EnumConstant<T>>) {
    this.constants = { ...constants }
  }

  getLabelByKey(key: keyof typeof this.constants): string {
    return this.constants[key].label
  }

  getLabelByValue(value: T): string {
    const entry = Object.values(this.constants).find((item) => item.value === value)
    if (!entry) throw new Error(`未知的值: ${value}`)
    return entry.label
  }

  /**
   * 安全获取label，未找到时返回undefined
   */
  getLabelByValueSafe(value: T): string | undefined {
    const entry = Object.values(this.constants).find((item) => item.value === value)
    return entry?.label
  }

  getKeyByValue(value: T): keyof typeof this.constants {
    const entry = Object.entries(this.constants).find(([, item]) => item.value === value)
    if (!entry) throw new Error(`未知的值: ${value}`)
    return entry[0] as keyof typeof this.constants
  }

  /**
   * 安全获取key，未找到时返回undefined
   */
  getKeyByValueSafe(value: T): keyof typeof this.constants | undefined {
    const entry = Object.entries(this.constants).find(([, item]) => item.value === value)
    return entry ? (entry[0] as keyof typeof this.constants) : undefined
  }

  addOption(key: string, option: EnumConstant<T>): void {
    this.constants[key] = option
  }

  toOptions(): EnumConstant<T>[] {
    return Object.values(this.constants)
  }
}
